import React from 'react';
import { useNavigate } from 'react-router-dom';

const PurchaseInfo = ({ coin, purchaseTransaction, formatDate }) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Purchase Information</h3>
      </div>
      <dl className="divide-y divide-gray-200">
        {purchaseTransaction ? (
          <>
            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Transaction</dt>
              <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
                <button 
                  onClick={() => navigate(`/transactions?view=${purchaseTransaction.id}&type=purchases`)}
                  className="text-indigo-600 hover:text-indigo-900"
                >
                  {purchaseTransaction.id}
                </button>
              </dd>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Purchased From</dt>
              <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
                {purchaseTransaction.contact_id ? (
                  <button 
                    onClick={() => navigate(`/contacts/${purchaseTransaction.contact_id}`)}
                    className="text-indigo-600 hover:text-indigo-900"
                  >
                    {purchaseTransaction.contact_name}
                  </button>
                ) : '-'}
              </dd>
            </div>
            <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Purchase Date</dt>
              <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
                {purchaseTransaction.transaction_date ? formatDate(purchaseTransaction.transaction_date) : '-'}
              </dd>
            </div>
          </>
        ) : (
          <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Purchase Date</dt>
            <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
              {coin.purchase_date ? formatDate(coin.purchase_date) : '-'}
            </dd>
          </div>
        )}
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Purchase Price</dt>
          <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
            {coin.purchase_price ? `$${parseFloat(coin.purchase_price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-'}
          </dd>
        </div>
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Shipping Cost</dt>
          <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
            {coin.shipping_cost ? `$${parseFloat(coin.shipping_cost).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-'}
          </dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Grading Cost</dt>
          <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
            {coin.grading_cost ? `$${parseFloat(coin.grading_cost).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-'}
          </dd>
        </div>
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Total Cost</dt>
          <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
            {coin.total_cost ? `$${parseFloat(coin.total_cost).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-'}
          </dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Price Guide</dt>
          <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
            {coin.price_guide_value ? `$${parseFloat(coin.price_guide_value).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-'}
          </dd>
        </div>
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">List Price</dt>
          <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
            {coin.list_price ? `$${parseFloat(coin.list_price).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}` : '-'}
          </dd>
        </div>
        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-5 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Storage Loc.</dt>
          <dd className="text-sm text-gray-900 sm:col-span-2 my-auto">
            {coin.storage_location || '-'}
          </dd>
        </div>
      </dl>
    </div>
  );
};

export default PurchaseInfo;
